import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import AuthStore from './modules/auth.store'
import BillingCodesStore from './modules/billing-codes.store'
import BlacklistsStore from './modules/blacklists.store'
import BroadcastStore from './modules/broadcast.store'
import BulkUnsubscriptionStore from './modules/bulk-unsubscription.store'
import CarrierPoliciesStore from './modules/carriers-policies.store'
import CarriersStore from './modules/carriers.store'
import CountriesStore from './modules/countries.store'
import DirectSubscriptionStore from './modules/direct-subscription.store'
import FiltersStore from './modules/filters.store'
import MenuItemStore from './modules/menu-item.store'
import MenuStore from './modules/menu.store'
import MessagesStore from './modules/messages.store'
import MonitorStore from './modules/monitor.store'
import PermissionsStore from './modules/permissions.store'
import ProductKeywordsStore from './modules/product-keywords.store'
import ProductsStore from './modules/products.store'
import ProvidersStore from './modules/providers.store'
import ReportAgendPeriodicitiesStore from './modules/report-agend-periodicities.store'
import ReportAgendsStore from './modules/report-agends.store'
import ReportCategoriesStore from './modules/report-categories.store'
import ReportChartTypesStore from './modules/report-chart-types.store'
import ReportDatasourcesStore from './modules/report-datasources.store'
import ReportsStore from './modules/reports.store'
import RolesStore from './modules/roles.store'
import ShortcodesStore from './modules/shortcodes.store'
import SnackbarsStore from './modules/snackbars.store'
import StatementStore from './modules/statement.store'
import StatementNotificationStore from './modules/statement-notification.store'
import ThemesStore from './modules/themes.store'
import UsersStore from './modules/users.store'
import WidgetsStore from './modules/widgets.store'
import WhitelistOneShotStore from './modules/whitelist-one-shot.store'
Vue.use(Vuex)
const store = new Vuex.Store({
    modules: {
        AuthStore,
        BillingCodesStore,
        BlacklistsStore,
        CarrierPoliciesStore,
        CarriersStore,
        CountriesStore,
        MenuItemStore,
        MenuStore,
        MessagesStore,
        MonitorStore,
        PermissionsStore,
        ProductKeywordsStore,
        ProductsStore,
        ProvidersStore,
        RolesStore,
        ShortcodesStore,
        SnackbarsStore,
        ThemesStore,
        UsersStore,
        StatementStore,
        StatementNotificationStore,
        ReportCategoriesStore,
        ReportDatasourcesStore,
        ReportChartTypesStore,
        ReportsStore,
        FiltersStore,
        ReportAgendPeriodicitiesStore,
        ReportAgendsStore,
        WidgetsStore,
        BulkUnsubscriptionStore,
        BroadcastStore,
        DirectSubscriptionStore,
        WhitelistOneShotStore
    }
})

export default store
